import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {SubscriptionModel} from '../subscription.model';
import {Injectable} from '@angular/core';
import {AccountSummaryConverter} from '../../../../account/common/api.converter/AccountSummary.converter';
import {ProviderServiceConverter} from "../../../../provider/service/api/entity/converter/providerService.converter";
import {PartnerSummaryConverter} from "../../../../partner/common/api/converter/partnerSummary.converter";
import {SubscriptionSummaryConverter} from "./subscriptionSummary.converter";
import {PriceListSummaryConverter} from "../../../pricelist/api/entity/converter/priceListSummary.converter";
import {LovValueSummaryConverter} from "../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {DateConverter} from "../../../../common/converter/date.converter";

@Injectable({
    providedIn: 'root'
})
export class SubscriptionConverter extends HttpModelConverter<SubscriptionModel> {

    constructor(private providerServiceConverter: ProviderServiceConverter,
                private partnerSummaryConverter: PartnerSummaryConverter,
                private summaryConverter: SubscriptionSummaryConverter,
                private accountSummaryConverter: AccountSummaryConverter,
                private priceListSummaryConverter: PriceListSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private dateConverter: DateConverter) {
        super();
    }

    protected createInstance(): SubscriptionModel {
        return new SubscriptionModel();
    }

    protected enrichObject(result: SubscriptionModel, src: SubscriptionModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.providerService = this.providerServiceConverter.convert(src.providerService);
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.account = this.accountSummaryConverter.convert(src.account);
        result.priceList = this.priceListSummaryConverter.convert(src.priceList);
        result.billingFrequency = this.lovValueSummaryConverter.convert(src.billingFrequency);
        result.billingType = this.lovValueSummaryConverter.convert(src.billingType);
        result.startDate = this.dateConverter.convert(src.startDate);
        result.endDate = this.dateConverter.convert(src.endDate);
    }
}
